import { Box, Typography } from "@mui/material";
import {
  facilityTypePattern,
  facilityTypePatternChangeOver,
  facilityTypePatternOther,
  fakeTable,
  headList,
  schema,
  stepperData,
} from "./parts";
import TkStepper from "../../components/atoms/TkStepper";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import React, { useContext, useEffect, useRef, useState } from "react";
import TkTable from "../../components/atoms/TkTable";
import TkButton from "../../components/atoms/TkButton";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  httpAPI_COM009,
  httpIAPI_COM005,
  httpIAPI_FAC011,
  httpIAPI_FAC020,
  httpIAPI_FAC039,
} from "./api/request";
import { useLocation, useNavigate } from "react-router-dom";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { ITkDataTableBodyProps } from "../../type/componentsType/TkDataTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import "./_style.scss";
import {
  ConfirmStatus,
  FacilityKind,
  FormClassApply,
  formClassFacility,
  FormKbn,
  FormOutputStatus,
} from "../../assets/data/Constants";
import { IAPI_FAC020_Response } from "../../type/apiType";
import _ from "lodash";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC050127 部分解除　内容入力
 * @returns {JSX.Element}
 */
const SCRC050127: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [fakeTableList, setFakeTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTable));
  const [downloadLinkActive, setDownloadLinkActive] = useState(false);
  const apiDataRef = useRef<IAPI_FAC020_Response>({});
  const apiData = apiDataRef.current;

  const incompleteRef = useRef<boolean>(true);
  const [selectedStaff, setSelectedStaff] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<any>();
  const [reason, setReason] = useState<any>();
  const refCancelStaffNum = useRef<number>(0);
  const [requestFlg, setRequestFlg] = useState<"0" | "1">();
  const [openWarning, setOpenWarning] = useState(false);

  const timerId = useRef<NodeJS.Timeout | null>(null);
  const [file, setFile] = useState<{
    fileName: string;
    fileBase64: string;
  }>({
    fileName: "",
    fileBase64: "",
  });

  const [clickedCreationRequestBtn, setClickedCreationRequestBtn] =
    useState<boolean>(false);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const applyId = businessState.job_16?.applyId;
  const facilityNo = businessState.job_16?.facilityNo;

  useEffect(() => {
    handleInit();

    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadData = async () => {
    try {
      // 帳票作成状況取得APIを呼び出す。
      const res = await httpAPI_COM009({
        applyId: applyId,
        FormList: [
          { formClass: FormClassApply["解除同意書"], formKbn: FormKbn["申請"] },
        ],
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        let requestId = "";
        res.FormList?.forEach((form) => {
          if (
            form.formOutputStatus === FormOutputStatus["出力完了"] &&
            form.facilityNo === facilityNo
          ) {
            requestId = form.requestId!;
            handleDownload(requestId);
          }
        });
        clearTimeout(timerId.current!);

        if (!requestId) {
          timerId.current = setTimeout(() => {
            handleDownloadData();
          }, 10000);
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
          errorMsgValues: selectedDate,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDownload = async (requestId: string) => {
    // 帳票ダウンロード(汎用)APIを呼び出す
    try {
      const res = await httpIAPI_COM005({
        formList: [{ requestId: requestId }],
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setFile({
          fileName: res.formList?.[0].fileName || "",
          fileBase64: res.formList?.[0].fileBase64 || "",
        });
        setDownloadLinkActive(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 部分解除施設詳細参照API実行
  const handleInit = async () => {
    try {
      const res = await httpIAPI_FAC020({
        contractorNo,
        applyId,
        facilityList: [{ facilityNo }],
      });

      if (res.resultCd === "I0000") {
        apiDataRef.current = res;

        let tableArr = stateFakeTableList.current;
        let facilityList = res.targetFacilityList![0];

        // 解除年月日
        let date = tableArr.find((item) => item.keyword === "datePicker")!;
        date.onGetInputValue = (e: any) => setSelectedDate(e.target?.value);
        date.setDefaultValue = facilityList.cancelDate;
        setSelectedDate(facilityList.cancelDate);

        // 解除対象となる職員の選択
        let select = tableArr.find((item) => item.keyword === "select")!;
        select.setDefaultValue = facilityList.partialCancel;
        setSelectedStaff(facilityList.partialCancel);
        select.onGetValue = setSelectedStaff;
        if (facilityList.changeoverReportFlg === "0") {
          let labelValues;
          facilityTypePattern.forEach((item) => {
            const baseDateObj = new Date(item.baseDate);
            const foundDateObj = new Date(facilityList?.foundDate!);
            const previousBool = foundDateObj < baseDateObj;
            if (item.pattern.includes(facilityList.facilityKind!)) {
              labelValues = previousBool ? item.options : item.otherOptions;
            }
          });
          if (labelValues) {
            select.selectPropsList = labelValues;
          } else {
            select.selectPropsList = facilityTypePatternOther;
          }
        } else {
          select.selectPropsList = facilityTypePatternChangeOver;
        }

        // 解除同意書の添付
        let fileUpload = tableArr.find(
          (item) => item.keyword === "fileUpload"
        )!;
        let settingFile = res.formList?.find(
          (item) =>
            item.formClass === formClassFacility["部分解除同意書"] &&
            item.formKbn === FormKbn["施設書類"] &&
            facilityNo === item.facilityNo
        )!;
        if (settingFile) {
          fileUpload.setDefaultValue = [
            {
              formName: settingFile?.fileName ?? "",
              fileBase64: settingFile?.fileBase64 ?? "",
            },
          ];
        }

        // 解除理由
        let cancelReason = tableArr.find(
          (item) => item.keyword === "cancelReason"
        )!;
        cancelReason.setDefaultValue = facilityList.cancelReason;
        setReason(facilityList.cancelReason);
        cancelReason.onGetInputValue = setReason;

        setFakeTableList([...tableArr]);

        // 持回情報
        setBusinessState({
          ...businessState,
          job_16: {
            ...businessState.job_16,
            applyId: res.applyId,
          },
        });

        setRequestFlg(res.requestFlg);
        // ・1.(2).解除同意書作成依頼フラグに応じて活性/非活性の制御を行う。
        if (res.requestFlg === "1") {
          // 非同期処理を開始する
          handleDownloadData();
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
          errorMsgValues: selectedDate,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let tableArr = stateFakeTableList.current;
    let facilityList = apiDataRef.current?.targetFacilityList?.[0];
    let target = facilityList?.numberOfRetireesInTheLastThreeMonthsList?.find(
      (item) => item.partialCancelTarget === selectedStaff
    );
    let numberOfRetirees = target?.numberOfRetireesInTheLastThreeMonths;
    let numberOfRegistrations =
      target?.numberOfCertificateRegistrationsForRetireesInTheLast3Months;
    let status = numberOfRetirees
      ? numberOfRetirees === numberOfRegistrations
        ? "完了"
        : "未完了"
      : "不要";
    let registrationInfo =
      facilityList?.joinStaffNum === 0
        ? "不要"
        : !!facilityList?.cancelDate
        ? !numberOfRetirees
          ? "不要"
          : numberOfRetirees === numberOfRegistrations
          ? `完了（${numberOfRegistrations}人 / ${numberOfRetirees}人）`
          : `未完了（${numberOfRegistrations}人 / ${numberOfRetirees}人）`
        : "未完了（-人 / -人）";

    let bodyList: ITkDataTableBodyProps[][] = [
      [
        {
          children: facilityList?.facilityNo
            ? facilityList.facilityNo + ":" + (facilityList.facilityName ?? "")
            : "",
        },
        {
          children:
            FacilityKind[
              facilityList?.facilityKind as keyof typeof FacilityKind
            ],
        },
        {
          children: (
            <Box className="tkBtn">
              <TkButton
                onClick={() =>
                  toConditionUpdate({
                    facilityName: facilityList?.facilityName,
                    facilityKind: facilityList?.facilityKind,
                  })
                }
                disabled={requestFlg === "0"}
              >
                表示
              </TkButton>
            </Box>
          ),
        },
        {
          children: (
            <Box className="tkBtn">
              <>
                <TkButton
                  onClick={to3MonthRetireList}
                  disabled={
                    requestFlg === "0" ||
                    !target?.numberOfRetireesInTheLastThreeMonths
                  }
                >
                  登録
                </TkButton>
                <Typography>{registrationInfo}</Typography>
              </>
            </Box>
          ),
        },
      ],
    ];
    tableArr.find((item) => item.keyword === "table")!.node = (
      <Box className="table">
        <TkTable headList={headList} bodyList={bodyList} />
      </Box>
    );
    // 部分解除の人数
    tableArr.find((item) => item.keyword === "num")!.text =
      facilityList?.joinStaffNum === 0
        ? "0人"
        : !facilityList?.cancelDate
        ? "-人"
        : selectedStaff
        ? (target?.cancelMaStaffNum ?? "") + "人"
        : "";
    setFakeTableList([...tableArr]);

    incompleteRef.current = status === "未完了";
    refCancelStaffNum.current = target?.cancelMaStaffNum ?? 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestFlg]);

  useEffect(() => {
    // テーブルデータ
    if (Object.keys(apiData).length === 0) {
      return;
    }
    let isStaffNumZero = apiData.targetFacilityList?.[0].joinStaffNum === 0;
    let tableArr = stateFakeTableList.current;
    tableArr?.forEach((tableData) => {
      switch (tableData?.keyword) {
        case "datePicker":
        case "select":
          // 解除同意書作成依頼フラグ"0"→活性
          tableData.disabled = requestFlg !== "0";
          break;
        case "fileUpload":
          if (isStaffNumZero) {
            tableData.type = "text";
            tableData.text = "不要";
          }
          tableData.disabled = requestFlg === "0";
          break;
        case "cancelReason":
          // 解除同意書作成依頼フラグ"1"→非活性
          tableData.disabled = !isStaffNumZero && requestFlg === "0";
          break;
        default:
          break;
      }
    });
    setFakeTableList([...tableArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestFlg]);

  // 表示ボタン押下
  const toConditionUpdate = (data: any) => {
    navigate("/SCRC050111", {
      state: {
        facilityName: data.facilityName,
        kindCd: data.facilityKind,
        cancelDate: selectedDate,
        cancelTarget: selectedStaff,
      },
    });
  };

  // 登録ボタン押下
  const to3MonthRetireList = () => {
    navigate("/SCRC050115", {
      state: { facilityNo: facilityNo || locationState?.facilityNo },
    });
  };

  //解除同意作成依頼ボタン押下持
  const onCliskCreationRequest = () => {
    const errorCheck = businessCheck();
    if (errorCheck) {
      return;
    }
    const today = new Date();
    const nextYearDate = new Date(
      today.setFullYear(today.getFullYear() + 1)
    ).setHours(0, 0, 0, 0);
    const inputDate = selectedDate
      ? new Date(selectedDate).setHours(0, 0, 0, 0)
      : null;
    if (inputDate && inputDate >= nextYearDate) {
      //入出力項目.解除年月日 ≧ システム日付 + 1年
      setOpenWarning(true);
      return;
    } else {
      getGeneralReportOutputRequestUpdate();
    }
  };

  const getGeneralReportOutputRequestUpdate = async () => {
    // 部分解除同意書帳票要求更新API実行
    try {
      const res = await httpIAPI_FAC039({
        contractorNo,
        applyId: apiData?.applyId,
        facilityList: [{ facilityNo }],
        cancelDate: selectedDate,
        partialCancel: selectedStaff,
        maStaffNum: refCancelStaffNum.current,
        cancelReason: reason,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        // 契約年月日と直近3カ月の退職者人数のデータを入れ替える
        apiDataRef.current = {
          ...apiDataRef.current,
          targetFacilityList:
            apiDataRef.current.targetFacilityList?.map?.((f) => ({
              ...f,
              cancelDate: selectedDate,
              numberOfRetireesInTheLastThreeMonthsList: [
                {
                  partialCancelTarget: selectedStaff,
                  numberOfRetireesInTheLastThreeMonths:
                    res.numberOfRetireesInTheLastThreeMonths,
                  numberOfCertificateRegistrationsForRetireesInTheLast3Months:
                    res.numberOfCertificateRegistrationsForRetireesInTheLast3Months,
                  cancelMaStaffNum: res.cancelMaStaffNum,
                },
              ],
            })) || [],
        };
        setRequestFlg("1");
        setDownloadLinkActive(false);
        setClickedCreationRequestBtn(true);
        handleDownloadData();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
          errorMsgValues: selectedDate,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSubmit = () => {
    setOpenWarning(false);
    getGeneralReportOutputRequestUpdate();
  };

  useEffect(() => {
    let tableArr = stateFakeTableList.current;
    let downloadLink = tableArr.find(
      (item) => item.keyword === "downloadLink"
    )!;

    const btnDisabled =
      apiDataRef?.current.requestFlg === "1" ||
      (apiDataRef?.current.requestFlg === "0" &&
        (!selectedDate || selectedDate === "Invalid Date" || !selectedStaff)) ||
      clickedCreationRequestBtn;

    let showReport = apiData.targetFacilityList?.[0]?.joinStaffNum !== 0;
    tableArr.find((item) => item.keyword === "explanatoryText02")!.showLine =
      showReport;
    downloadLink.showLine = showReport;
    downloadLink.node = (
      <Box className="downloadButton">
        <TkButton onClick={onCliskCreationRequest} disabled={btnDisabled}>
          解除同意書作成依頼
        </TkButton>
        <TkDownloadLink
          base64filedata={file.fileBase64}
          dataname={file.fileName ?? ""}
          buttonDisabled={!downloadLinkActive}
          linkDisabled={!downloadLinkActive}
          downloadBase64={true}
          isButton={true}
          buttonName="解除同意書をダウンロード"
        />
      </Box>
    );
    setFakeTableList([...tableArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    downloadLinkActive,
    selectedStaff,
    selectedDate,
    clickedCreationRequestBtn,
    requestFlg,
  ]);

  // 業務チェック
  const businessCheck = () => {
    const inputDate = selectedDate ? new Date(selectedDate) : null;
    if (state.authInfo?.confirmStatus !== ConfirmStatus["確定済"]) {
      const nowYear = new Date(
        Number(state.authInfo?.fiscalYear) - 1 + "/03/31"
      );
      if (inputDate && inputDate <= nowYear) {
        //当年度の確定前、かつ入出力項目.解除年月日 ≦ 前年度末（３月３１日）
        setState({
          ...state,
          errorMsgId: "TKMSG_SCR0091E",
        });
        return true;
      }
    }

    setState({
      ...state,
      errorMsgId: "",
    });
    return false;
  };

  // 登録
  const onCheckAndSubmit = async (data: any) => {
    const errorCheck = businessCheck();
    if (errorCheck) {
      return;
    }

    // 退職手当共済契約部分解除更新API 呼び出し
    try {
      const res = await httpIAPI_FAC011({
        contractorNo,
        applyId: apiData.applyId,
        latestApplyStatus: apiData.latestApplyStatus,
        facilityList:
          apiData.targetFacilityList?.map((item) => {
            return { facilityNo: item.facilityNo };
          }) || [],
        cancelDate: data.datePicker,
        partialCancel: selectedStaff,
        maStaffNum: refCancelStaffNum.current,
        cancelReason: data?.cancelReason,
        formList:
          data.fileUpload && data.fileUpload.length > 0
            ? [
                {
                  serialNo: 1,
                  facilityNo: facilityNo,
                  formKbn: FormKbn["施設書類"],
                  formClass: formClassFacility["部分解除同意書"],
                  fileName: data.fileUpload[0].formName,
                  fileBase64: data.fileUpload[0].fileBase64,
                },
              ]
            : undefined,
        screenId: "SCRC050127",
      });

      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC050126");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
          errorMsgValues: data.datePicker,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC050127test" className="SCRC050127">
      <TkStepper steps={stepperData} activeStep={1} />
      {isKiko && (
        <Box className="conSec">
          <TkContractorAndNumberLine
            name="契約者(法人)名"
            no={
              businessState.common?.contractorNo +
              ":" +
              businessState.common?.contractorName
            }
          />
        </Box>
      )}
      <TkInfoManual rule="\n">{labelids.labelid.LBLC050127_01}</TkInfoManual>
      <TkFakeTable
        list={fakeTableList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        buttonGroup={<TkBackButton />}
        disabled={incompleteRef.current}
        submitButtonText="登録"
      />
      <TkMessageDialog
        open={openWarning}
        onOky={handleSubmit}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0025W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC050127;
